
<div class="choose_fabric_cont_outer" *ngIf="fabricProfile">
	<h3>
		<span class="fabric_label">Choose Fabric</span>
		<span class="fabric_name">{{selectedFabricName | truncketHtml: 20}}</span>
	</h3>
	<div class="choose_fabric_cont_with_more_option">
		<div class="choose_fabric_cont_inner">
			<!--	TODO: do not remove for now		-->
			<!-- <button (click)="selectFabricOption((i+1),null,fabric, fabric.mockupImage)"
					(mouseenter)="moreFabricnfo(i+1)"
					(mouseleave)="moreFabricnfoRemove($event)"
					class="{{deltaIndex==(i+1)?'active':''}} {{deltaIndexForMoreInfo==(i+1)?'active_pop':''}} choose_outer_fabric">

					<img src="{{fabric.fabricPreview.heroImage}}" alt="{{fabric.mockupText}}" />

					<div class="morefabric_inner {{deltaIndex==(i+1)?'show':''}}">

						<span class="close"  (click)="moreFabricnfoRemove($event)">
							<span class="material-symbols-outlined">
								close
							</span>
						</span>

						<fb-choose-more-fabric-finish-outer [name]="fabric.fabricPreview.name"
							[price]="fabric.fabricPreview.price+''" [currency]="''"
							[image]="fabric.fabricPreview.heroImage" [unit]="''"
							[overview]="fabric.fabricPreview.productOverview">
						</fb-choose-more-fabric-finish-outer>
					</div>
				</button> -->

			<button *ngIf="madeToOrderFabric"
				(click)="selectFabricOption(0,madeToOrderFabric,null, madeToOrderFabric.heroImage)"
				(mouseleave)="moreFabricInfoRemove($event)"
				class="{{deltaIndex==0?'active':''}} {{deltaIndexForMoreInfo==0?'active_pop':''}} choose_outer_fabric" (mouseenter)="moreFabricInfo(0)"
				>
				<!-- 'mto' -->
				<img src="{{ madeToOrderFabric.heroImage}}" alt="{{ madeToOrderFabric.name}}" />

				<div class="morefabric_inner  {{deltaIndex==0?'show':''}}">

					<span class="close" (click)="moreFabricInfoRemove($event)">
						<span class="material-symbols-outlined">
							close
						</span>
					</span>

					<fb-choose-more-fabric-finish-outer [name]="madeToOrderFabric.name"
						[price]="madeToOrderFabric.price+''" [currency]="madeToOrderFabric.price+''"
						[image]="madeToOrderFabric.heroImage" [unit]="madeToOrderFabric.unit" [overview]="madeToOrderFabric.name">
					</fb-choose-more-fabric-finish-outer>
				</div>
			</button>

			<ng-container *ngFor="let fabric of fabricProfile; let i = index">
				<button (click)="selectFabricOption((i+1),null,fabric, fabric.mockupImage)"
					(mouseenter)="moreFabricInfo(i+1)"
					(mouseleave)="moreFabricInfoRemove($event)"
					class="{{deltaIndex==(i+1)?'active':''}} {{deltaIndexForMoreInfo==(i+1)?'active_pop':''}} choose_outer_fabric">

					<img src="{{fabric.fabricPreview.heroImage}}" alt="{{fabric.mockupText}}" />

					<div class="morefabric_inner {{deltaIndex==(i+1)?'show':''}}">

						<span class="close"  (click)="moreFabricInfoRemove($event)">
							<span class="material-symbols-outlined">
								close
							</span>
						</span>

						<fb-choose-more-fabric-finish-outer [name]="fabric.fabricPreview.name"
							[price]="fabric.fabricPreview.price+''" [currency]="''"
							[image]="fabric.fabricPreview.heroImage" [unit]="fabric.fabricPreview.unit"
							[overview]="fabric.fabricPreview.productOverview">
						</fb-choose-more-fabric-finish-outer>
					</div>
				</button>
			</ng-container>

			<div *ngIf="fabricProfileMoreThan7.length>0" class="more_option_button not_button_like  image_button
				{{deltaIndex===-5?'active':''}}" (click)="showFabricMoreOption()" (mouseenter)="moreFabricInfo(-5)"
				(mouseleave)="moreFabricInfoRemove($event)">
				<img src="https://dummyimage.com/200x200/fff/fff" alt="Dummy image">
				<span>+{{fabricProfileMoreThan7.length}}</span>
			</div>
		</div>
	</div>
	<fb-choose-fabric-more-option *ngIf="showMore"
		[productData]="fabricData"
		[moreFabricList]="this.fabricData.fabricProfile!.fabricProfileItemList"
		[madeToOrderFabric]="madeToOrderFabric"
		(closeMoreFabric)="closeFabricMoreOption()"
		(continueOption)="continueMoreClick($event)"
		(continueOptionForMTO)="continueClickWithMTOSelected()"
		(moreFabricImageUpdateInDisplayImage)="fromSelectFabricOption(fabricProfileMoreThan7.length+1,$event)">
	</fb-choose-fabric-more-option>
</div>
